<template>
<!-- Scenarios -->
    <section class="scenarios">
        <h2 class="section-title">See Pabu in Action</h2>
        
        <!-- Scenario 1: Operations -->
        <div class="scenario-card">
            <span class="scenario-status ready">✓ Ready Now</span>
            <h3>Daily Operations</h3>
            <div class="scenario-gif-container">
                <img src="../assets/images/pabu-daily-operations.gif" alt="Pabu handling daily operations - customer inquiry to confirmed booking" class="scenario-gif">
            </div>
        </div>

        <!-- Scenario 2: Intelligence -->
        <div class="scenario-card">
            <span class="scenario-status beta">🔧 In Development - Help Us Build It</span>
            <h3>Business Intelligence</h3>
            <div class="scenario-gif-container">
                <img src="../assets/images/pabu-business-intelligence.gif" alt="Pabu providing business intelligence insights with charts and data analysis" class="scenario-gif">
            </div>
        </div>

        <!-- Scenario 3: Strategic -->
        <div class="scenario-card">
            <span class="scenario-status beta">🔧 In Development - Help Us Build It</span>
            <h3>Strategic Guidance</h3>
            <div class="scenario-gif-container">
                <img src="../assets/images/pabu-strategic-guidance.gif" alt="Pabu providing strategic pricing guidance with market analysis and revenue projections" class="scenario-gif">
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "ScenariosSection"
  /*
  data() {
    return {
      image1: require("@/assets/images/abouts-1.jpg"),
      image2: require("@/assets/images/abouts-2.jpg"),
      graphic1: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Graphics/splash-4.svg",
      graphic2: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Graphics/tire-mark.svg",
      features: [
        "Daily Personal Activities & Assistance",
        "Travel & Transport Support",
        "Community & Social Participation",
        "Household Task Assistance",
        "Community Nursing Care"
      ]
    };
  }*/
};
</script>

<style scoped>

</style>
